import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NothingHereIconComponent, RefreshIconComponent } from '@kuiper/icons';

@Component({
  selector: 'lib-error-screen',
  imports: [TranslocoPipe, NothingHereIconComponent, RefreshIconComponent],
  templateUrl: './error-screen.component.html',
  host: {
    class: 'block',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ErrorScreenComponent {
  retryCount = input<number>(1);
  errorTitleKey = input<string>('expand_all_error_screen_title_first_time');
  errorSecondTitleKey = input<string>(
    'expand_all_error_screen_title_second_time'
  );
  errorDescriptionKey = input<string>('expand_all_error_screen_description');
  errorSecondDescriptionKey = input<string>(
    'expand_all_error_screen_load_error_second_description'
  );
  retryButtonKey = input<string>('expand_all_error_screen_retry_button_label');
  retry = output<void>();

  onRetry() {
    this.retry.emit();
  }
}
